import { useState, useEffect } from 'react';
import i18n from '../i18n';

const getLocale = () => {
  const lang = i18n.language || 'fr';
  if (lang === 'ar') return 'ar-TN';
  if (lang === 'en') return 'en-GB';
  return 'fr-FR';
};

export const useCurrentTime = (updateInterval = 60000) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [locale, setLocale] = useState(getLocale());

  useEffect(() => {
    setCurrentTime(new Date());
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, updateInterval);
    return () => clearInterval(interval);
  }, [updateInterval]);

  useEffect(() => {
    const handler = () => setLocale(getLocale());
    i18n.on('languageChanged', handler);
    return () => i18n.off('languageChanged', handler);
  }, []);

  const formatDateTime = (date) => {
    return date.toLocaleDateString(locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatFullDateTime = (date) => {
    return `${formatDateTime(date)} ${formatTime(date)}`;
  };

  return {
    currentTime,
    formatDateTime: () => formatDateTime(currentTime),
    formatTime: () => formatTime(currentTime),
    formatFullDateTime: () => formatFullDateTime(currentTime)
  };
}; 